import React, { FC, useEffect, useState } from "react";
import authService from "@http/services/auth.service";
import { useRouter } from "next/router";

const PrivateRoute: FC = ({ children }) => {
  const router = useRouter();
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

  useEffect(() => {
    let mounted = true;

    const checkAuth = async () => {
      try {
        const user = await authService.fetchUser();
        if (!mounted) {
          return;
        }

        if (user) {
          setIsAuthorized(true);
        } else {
          setIsAuthorized(false);
          router.replace({
            pathname: "/",
            query: { redirect: router.asPath },
          });
        }
      } catch {
        if (!mounted) {
          return;
        }
        setIsAuthorized(false);
        router.replace({
          pathname: "/",
          query: { redirect: router.asPath },
        });
      }
    };

    checkAuth();

    return () => {
      mounted = false;
    };
  }, [router]);

  if (isAuthorized !== true) {
    return null;
  }

  return <>{children}</>;
};

export default PrivateRoute;
